import React from 'react'
import { ArrowDown2, ArrowUp2 } from 'iconsax-react'
import styled, { css } from 'styled-components'

import IconButton, { SIZES, VARIANTS } from 'components/lib/DesignSystem/V3/IconButton'
import Tooltip from 'components/lib/DesignSystem/V3/Tooltip'

import { NAV_ACTIONS } from '../navActions'

/* `bare` drops the pill chrome for cases that are just a pair of arrows next to a label
   that already exists on the surface. */
const Container = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(--t-spacing-1);
  color: var(--color-text);
  font-size: var(--t-typography-font-size-sm);
  font-weight: var(--t-typography-font-weight-medium);

  ${({ $bare }) =>
    !$bare &&
    css`
      border-radius: var(--t-border-radius-md);
      padding: var(--t-spacing-1) var(--t-spacing-2);
      background: var(--color-elevated);
      box-shadow: var(--shadow-1);
      border: 1px solid var(--card-border-color);
    `}

  /* Same treatment as the incidents drawer nav: the V3 filled IconButton is palette-hardcoded
     (blue-100 fill, blue-950 icon) and reads as a light chip on the dark drawer. */
  html[data-theme='dark'] & button {
    background-color: rgba(90, 142, 255, 0.34);
    border-color: rgba(90, 142, 255, 0.7);
    color: #ffffff;
  }
  html[data-theme='dark'] & button:hover:not(:disabled) {
    background-color: rgba(90, 142, 255, 0.5);
    border-color: var(--t-colors-blue-400, #5a8eff);
  }
  html[data-theme='dark'] & button:disabled {
    background-color: rgba(255, 255, 255, 0.06);
    border-color: rgba(255, 255, 255, 0.08);
    color: var(--color-text-tertiary, rgba(255, 255, 255, 0.4));
    opacity: 1;
  }
`

/**
 * Step forward and back through a list without leaving the drawer: used both for the
 * recipients of one simulation and for the simulations themselves.
 */
const DrawerNav = ({
  hasPrev,
  hasNext,
  onNavigate,
  testIdPrefix,
  prevLabel = 'Previous',
  nextLabel = 'Next',
  bare = false,
}) => (
  <Container data-testid={`${testIdPrefix}_div`} $bare={bare}>
    <Tooltip id={`${testIdPrefix}_Prev_tooltip`} content={prevLabel}>
      <IconButton
        id={`${testIdPrefix}_Prev_button`}
        ariaLabel={prevLabel}
        dataTestId={`${testIdPrefix}_Prev_icon_container_div`}
        disabled={!hasPrev}
        size={SIZES.SMALL}
        variant={bare ? VARIANTS.FILLED : VARIANTS.GHOST}
        onClick={() => onNavigate(NAV_ACTIONS.PREV)}
      >
        <ArrowUp2 size={16} variant="Outline" />
      </IconButton>
    </Tooltip>
    <Tooltip id={`${testIdPrefix}_Next_tooltip`} content={nextLabel}>
      <IconButton
        id={`${testIdPrefix}_Next_button`}
        ariaLabel={nextLabel}
        dataTestId={`${testIdPrefix}_Next_icon_container_div`}
        disabled={!hasNext}
        size={SIZES.SMALL}
        variant={bare ? VARIANTS.FILLED : VARIANTS.GHOST}
        onClick={() => onNavigate(NAV_ACTIONS.NEXT)}
      >
        <ArrowDown2 size={16} variant="Outline" />
      </IconButton>
    </Tooltip>
  </Container>
)

export default DrawerNav
